module.exports = __webpack_public_path__ + "img/glxx.4cec3480.png";